<script lang="ts">
    import { BookClass } from "@circleofa/acim-engine"

    // import { TextClass, type BookClass, WorkbookClass, ClarificationClass, Introduction, ManualForTeachersClass } from "@circleofa/acim-engine"
    import { getColor } from "@utils/reading/category-colors"
    import { twMerge } from "tailwind-merge"

    export let category: BookClass["dendrites"][number]

    let className = ""
    export { className as class }

    const { color, colorDark, text } = getColor(category)
    const css = color
    const cssDark = colorDark
</script>

<div
    class={twMerge(
        css,
        cssDark,
        "rounded-full inline-block px-2 py-0.5 uppercase font-semibold text-sm",
        className,
    )}
    {...$$restProps}
>
    <slot>
        {text}
    </slot>
</div>
